module.exports = __webpack_public_path__ + "static/media/mobile_phone.4d813d7f.png";